import { formatDate } from "../formating"
import { getAdjustedDate, getFormattedDate } from "./index"

export default function getDateObject({ date, displayOptions, dateString }) {
	if (!date) return {}

	date = {
		display: getFormattedDate({ date, options: displayOptions }),
		value: getAdjustedDate({ date })
	}

	if (dateString) date.dateString = formatDate({ data: date.value, actions: ["mysql"] })
	return date
}
